var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mapContainer"}},[_c('button',{staticClass:"but",on:{"click":function($event){return _vm.bdMap()}}},[_vm._v("还原")])])}
var staticRenderFns = []

export { render, staticRenderFns }